import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const key = (params) => ['getExecuters', ...Object.values(params)];

export const getExecuters = async (params) => {
  return await request.get(
    '/Request/executers',
    params,
    'При получении списка исполнителей произошла ошибка'
  );
};

const useExecutersQuery = (params, options) =>
  useQuery(key(params), () => getExecuters(params), options);

export default useExecutersQuery;
